const NAVIGATIONS_LIST = [
    {
      label: 'containers.manage.nvqualSubmissions.approvalCard.title',
      to: 'Approve Nvqual Submissions'
    }
]

const NVQUAL_SUBMISSIONS = 'fulcrum/container/Manage/NvqualSubmissions/NvqualSubmissions'
const MOUNT = 'fulcrum/container/Manage/NvqualSubmissions/NvqualSubmissions/MOUNT'
const UNMOUNT = 'fulcrum/container/Manage/NvqualSubmissions/NvqualSubmissions/UNMOUNT'

export {
  NVQUAL_SUBMISSIONS,
  MOUNT,
  UNMOUNT,
  NAVIGATIONS_LIST,
}
